import * as Cookie from '@/lib/util/cookies';

export default async ({ store, redirect, route }) => {
  const videoID = route.params.id;
  const {
    currentUser: { id: userID },
    isAuthenticated,
  } = store.state.auth;
  const video = await store.dispatch('video/getVideoGuest', videoID);
  const { inviteCode: currentInvitation, publicToSpace, spaceID } = video;
  const { inviteCode: queryInviteCode, groupID } = route.query;
  if (!currentInvitation || queryInviteCode !== currentInvitation) {
    return redirect('/space');
  }
  if (isAuthenticated) {
    const input = {
      spaceId: spaceID,
      userId: userID,
    };
    const [userProfile] = await store.dispatch('profile/getUserSpaceProfile', input);
    if (userProfile && userProfile.status === 'active') {
      if (publicToSpace) {
        return redirect(`/space/${spaceID}/video/${videoID}`);
      }
      const joinGroupFilter = {
        groupID: { eq: groupID },
        userID: { eq: userID },
      };
      const userGroup = await store.dispatch('group/listJoinGroups', { filter: joinGroupFilter });
      if (userGroup.length > 0) {
        return redirect(`/space/${spaceID}/group/${groupID}/video/${videoID}`);
      }
    }
    const spaceFilter = {
      userID: { eq: userID },
      type: { eq: 'default' },
    };
    const [spaceDefault] = await store.dispatch('space/listSpace', { filter: spaceFilter });
    if (spaceDefault && spaceDefault.id) {
      const inputDefault = {
        spaceId: spaceDefault.id,
        userId: userID,
      };
      const [userProfileDefault] = await store.dispatch('profile/getUserSpaceProfile', inputDefault); // eslint-disable-line
      if (userProfileDefault && userProfileDefault.status === 'active') {
        return redirect(`/video/${videoID}?inviteCode=${queryInviteCode}`);
      }
    }
  }
  // check if there is guest info saved in cookies
  const guestName = Cookie.default.getCookie('guestName');
  const accessKeyId = Cookie.default.getCookie('accessKeyId');
  const secretAccessKey = Cookie.default.getCookie('secretAccessKey');
  const sessionToken = Cookie.default.getCookie('sessionToken');
  if (guestName && accessKeyId && secretAccessKey && sessionToken) {
    const guestInfo = {
      accessKeyId,
      secretAccessKey,
      sessionToken,
    };
    await store.dispatch('guest/setGuestUser', { guestName, guestInfo });
    return redirect(`/video/${videoID}?inviteCode=${queryInviteCode}`);
  }
};
